import React, { Children, PropsWithChildren } from 'react';
import { Heading, HeadingHierarchy } from '../Heading/Heading';
import { useSonTranslation } from '../../../translation/useSonTranslation';

import { PostTypes } from './Post.types';

type PostsListProps = {
  headingHierarchy: HeadingHierarchy;
  type: PostTypes | 'reply';
  cleanUpPeriod?: number;
};

export function PostsList({ children, headingHierarchy, type, cleanUpPeriod }: PropsWithChildren<PostsListProps>) {
  const { t } = useSonTranslation('Posts');

  // don't show list if no posts are given.
  // maybe tell user there are no posts yet here ?
  if (Children.toArray(children).length === 0) {
    return null;
  }

  return (
    <div className="posts__list-container">
      <div className="posts__heading-container">
        <Heading
          hierarchy={headingHierarchy}
          className={type === 'reply' ? 'invisible' : 'posts__heading font-bold-15-19'}
        >
          {t(`default.heading.list.${type}`)}
        </Heading>
        {type === 'thread' && cleanUpPeriod && (
          <p className="posts__heading-delete-info font-regular-15-19">
            {cleanUpPeriod === 1
              ? t(`default.heading.list.threadDeleteAutomaticallySingular`, { cleanUpPeriod })
              : t(`default.heading.list.threadDeleteAutomaticallyPlural`, { cleanUpPeriod })}
          </p>
        )}
      </div>
      <ul className="posts__list">
        {Children.map(children, child => (
          <li className="posts__list-item">{child}</li>
        ))}
      </ul>
    </div>
  );
}
